import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";

import * as React from "react";
import AnalyticsProvider from "./analytics/AnalyticsProvider.tsx";
import { Toaster } from "./components/ui/toaster.tsx";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const basename = import.meta.env.BASE_URL;

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <AnalyticsProvider>
        <App />
        <Toaster />
      </AnalyticsProvider>
    </BrowserRouter>
  </React.StrictMode>
);
